<template>
    <student-backend-focus-layout
        content-bg-color="gray-125"
        :hide-exit-button="true"
        :page-title="quizTitle"
    >
        <template #page_header>
            <div class="-mb-4">
                <div
                    class="mx-auto text-center font-semibold text-gray-925 md:hidden"
                >
                    {{ quizTitle }}
                </div>
            </div>
        </template>
        <template #content>
            <div class="flex w-full flex-col gap-4">
                <div class="flex-grow">
                    <div
                        class="mx-auto mb-24 flex h-full w-full select-none flex-col items-center justify-center gap-4 text-gray-700 md:mb-4"
                    >
                        <div class="animate animate-spin">
                            <svg
                                width="64"
                                height="63"
                                viewBox="0 0 64 63"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M63.5 31.5C63.5 48.897 49.397 63 32 63C14.603 63 0.5 48.897 0.5 31.5C0.5 14.103 14.603 0 32 0C49.397 0 63.5 14.103 63.5 31.5ZM8.26209 31.5C8.26209 44.6101 18.8899 55.2379 32 55.2379C45.1101 55.2379 55.7379 44.6101 55.7379 31.5C55.7379 18.3899 45.1101 7.76209 32 7.76209C18.8899 7.76209 8.26209 18.3899 8.26209 31.5Z"
                                    fill="#DDE1EA"
                                />
                                <path
                                    d="M32 2.43779e-06C25.7699 2.71012e-06 19.6797 1.84745 14.4995 5.30871C9.31939 8.76997 5.28195 13.6896 2.89779 19.4455C0.513633 25.2013 -0.110172 31.5349 1.10526 37.6453C2.3207 43.7557 5.32078 49.3685 9.72614 53.7739C14.1315 58.1792 19.7443 61.1793 25.8547 62.3947C31.9651 63.6102 38.2987 62.9864 44.0545 60.6022C49.8104 58.218 54.73 54.1806 58.1913 49.0005C61.6526 43.8203 63.5 37.7301 63.5 31.5L55.7379 31.5C55.7379 36.1949 54.3457 40.7844 51.7374 44.6881C49.129 48.5918 45.4216 51.6343 41.0841 53.431C36.7466 55.2276 31.9737 55.6977 27.369 54.7818C22.7643 53.8659 18.5346 51.605 15.2148 48.2852C11.895 44.9654 9.63414 40.7357 8.71821 36.131C7.80227 31.5263 8.27236 26.7534 10.069 22.4159C11.8657 18.0784 14.9082 14.371 18.8119 11.7626C22.7156 9.15429 27.3051 7.76209 32 7.76209L32 2.43779e-06Z"
                                    fill="#0685BB"
                                />
                            </svg>
                        </div>
                        <div class="text-[21px] font-semibold">
                            <span>Quiz complete!</span>
                        </div>
                        <div class="text-[21px]">
                            <span>
                                We are calculating your score. Please do not
                                exit this screen.
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </student-backend-focus-layout>
</template>

<script>
import StudentBackendFocusLayout from "@/_Layouts/NewStudentBackendFocusLayout.vue";

export default {
    name: "StudentQuizShow",
    components: {
        StudentBackendFocusLayout,
    },
    props: {
        quizId: {
            type: Number,
            default: null,
        },
        quizType: {
            type: String,
            default: "focus_area",
        },
        quizLength: {
            type: Number,
            default: 10,
        },
        quizTitle: {
            type: String,
            default: "",
        },
    },
    data() {
        return {};
    },
    methods: {},

    mounted() {
        let vm = this;
        setTimeout(function () {
            vm.$inertia.get(
                route("student.quiz.process", { student_quiz: vm.quizId })
            );
        }, 500);
    },
};
</script>

<style scoped></style>
